import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "prompt"
};
const _hoisted_2 = {
  class: "hot-words"
};
const _hoisted_3 = {
  class: "group-item"
};
const _hoisted_4 = {
  class: "group-item"
};
const _hoisted_5 = {
  class: "group-item"
};
const _hoisted_6 = {
  class: "group-item"
};
const _hoisted_7 = {
  class: "group-item"
};
const _hoisted_8 = {
  class: "group-item"
};
const _hoisted_9 = {
  class: "group-item"
};
const _hoisted_10 = {
  class: "btns"
};
import { ImageApi } from '@/api/ai/image';
import { hasChinese } from '@/views/aip/utils/utils';
import { AiPlatformEnum, ImageHotEnglishWords, StableDiffusionClipGuidancePresets, StableDiffusionSamplers, StableDiffusionStylePresets } from '@/views/aip/utils/constants';
import { ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    models: {
      type: Array,
      default: () => []
    }
  },
  emits: ['onDrawStart', 'onDrawComplete'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    // 接收父组件传入的模型列表
    const props = __props;
    const emits = __emit; // 定义 emits
    // 定义属性
    const drawIn = ref(false); // 生成中
    const selectHotWord = ref(''); // 选中的热词
    // 表单
    const prompt = ref(''); // 提示词
    const width = ref(512); // 图片宽度
    const height = ref(512); // 图片高度
    const sampler = ref('DDIM'); // 采样方法
    const steps = ref(20); // 迭代步数
    const seed = ref(42); // 控制生成图像的随机性
    const scale = ref(7.5); // 引导系数
    const clipGuidancePreset = ref('NONE'); // 文本提示相匹配的图像(clip_guidance_preset) 简称 CLIP
    const stylePreset = ref('3d-model'); // 风格
    /** 选择热词 */
    const handleHotWordClick = async hotWord => {
      // 情况一：取消选中
      if (selectHotWord.value == hotWord) {
        selectHotWord.value = '';
        return;
      }
      // 情况二：选中
      selectHotWord.value = hotWord; // 选中
      prompt.value = hotWord; // 替换提示词
    };
    /** 图片生成 */
    const handleGenerateImage = async () => {
      // 从 models 中查找匹配的模型
      const selectModel = 'stable-diffusion-v1-6';
      const matchedModel = props.models.find(item => item.model === selectModel && item.platform === AiPlatformEnum.STABLE_DIFFUSION);
      if (!matchedModel) {
        message.error('该模型不可用，请选择其它模型');
        return;
      }
      // 二次确认
      if (hasChinese(prompt.value)) {
        message.alert('暂不支持中文！');
        return;
      }
      await message.confirm(`确认生成内容?`);
      try {
        // 加载中
        drawIn.value = true;
        // 回调
        emits('onDrawStart', AiPlatformEnum.STABLE_DIFFUSION);
        // 发送请求
        const form = {
          modelId: matchedModel.id,
          prompt: prompt.value,
          // 提示词
          width: width.value,
          // 图片宽度
          height: height.value,
          // 图片高度
          options: {
            seed: seed.value,
            // 随机种子
            steps: steps.value,
            // 图片生成步数
            scale: scale.value,
            // 引导系数
            sampler: sampler.value,
            // 采样算法
            clipGuidancePreset: clipGuidancePreset.value,
            // 文本提示相匹配的图像 CLIP
            stylePreset: stylePreset.value // 风格
          }
        };
        await ImageApi.drawImage(form);
      } finally {
        // 回调
        emits('onDrawComplete', AiPlatformEnum.STABLE_DIFFUSION);
        // 加载结束
        drawIn.value = false;
      }
    };
    /** 填充值 */
    const settingValues = async detail => {
      prompt.value = detail.prompt;
      width.value = detail.width;
      height.value = detail.height;
      seed.value = detail.options?.seed;
      steps.value = detail.options?.steps;
      scale.value = detail.options?.scale;
      sampler.value = detail.options?.sampler;
      clipGuidancePreset.value = detail.options?.clipGuidancePreset;
      stylePreset.value = detail.options?.stylePreset;
    };
    /** 暴露组件方法 */
    __expose({
      settingValues
    });
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("画面描述")])),
        _: 1
      }), _createVNode(_component_el_text, {
        class: "mt-[5px]",
        tag: "p"
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("建议使用“形容词 + 动词 + 风格”的格式，使用“，”隔开")])),
        _: 1
      }), _createVNode(_component_el_input, {
        modelValue: prompt.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => prompt.value = $event),
        maxlength: "1024",
        rows: 5,
        class: "w-100% mt-[10px]",
        "input-style": "border-radius: 7px;",
        placeholder: "例如：童话里的小屋应该是什么样子？",
        "show-word-limit": "",
        type: "textarea"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("随机热词")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "word-list"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ImageHotEnglishWords), hotWord => {
          return _openBlock(), _createBlock(_component_el_button, {
            round: "",
            class: "btn",
            type: selectHotWord.value === hotWord ? 'primary' : 'default',
            key: hotWord,
            onClick: $event => handleHotWordClick(hotWord)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(hotWord), 1)]),
            _: 2
          }, 1032, ["type", "onClick"]);
        }), 128))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("采样方法")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "group-item-body [&_>div]:!w-full"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: sampler.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => sampler.value = $event),
          placeholder: "Select",
          size: "large",
          class: "!w-350px"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(StableDiffusionSamplers), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.key,
              label: item.name,
              value: item.key
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("CLIP")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "group-item-body [&_>div]:!w-full"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: clipGuidancePreset.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => clipGuidancePreset.value = $event),
          placeholder: "Select",
          size: "large",
          class: "!w-350px"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(StableDiffusionClipGuidancePresets), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.key,
              label: item.name,
              value: item.key
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("风格")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "group-item-body [&_>div]:!w-full"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: stylePreset.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => stylePreset.value = $event),
          placeholder: "Select",
          size: "large",
          class: "!w-350px"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(StableDiffusionStylePresets), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.key,
              label: item.name,
              value: item.key
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("图片尺寸")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        class: "group-item-body"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: width.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => width.value = $event),
          class: "w-170px",
          placeholder: "图片宽度"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
          modelValue: height.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => height.value = $event),
          class: "w-170px",
          placeholder: "图片高度"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("迭代步数")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "group-item-body"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: steps.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => steps.value = $event),
          type: "number",
          size: "default",
          class: "!w-[350px]",
          placeholder: "Please input"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("引导系数")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "group-item-body"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: scale.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => scale.value = $event),
          type: "number",
          size: "default",
          class: "!w-[350px]",
          placeholder: "Please input"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("随机因子")])),
        _: 1
      })]), _createVNode(_component_el_space, {
        wrap: "",
        class: "group-item-body"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: seed.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => seed.value = $event),
          type: "number",
          size: "default",
          class: "!w-[350px]",
          placeholder: "Please input"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        type: prompt.value.length === 0 ? 'info' : 'primary',
        size: "large",
        round: "",
        loading: drawIn.value,
        disabled: prompt.value.length === 0,
        onClick: handleGenerateImage
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(drawIn.value ? '生成中' : '生成内容'), 1)]),
        _: 1
      }, 8, ["type", "loading", "disabled"])])], 64);
    };
  }
});